(function(){
  function init(root){
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !motion) {
      var reveals = new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.remove('reveal-wait');entry.target.classList.add('reveal-seen');reveals.unobserve(entry.target);}});},{threshold:.08});
      root.querySelectorAll('.reveal:not([data-observed])').forEach(function(el){el.dataset.observed='true';el.classList.add('reveal-wait');reveals.observe(el);});
    }
    root.querySelectorAll('.mobile-menu a').forEach(function(a){a.addEventListener('click',function(){a.closest('details').open=false;});});
    var cards=Array.from(root.querySelectorAll('[data-sample]'));
    var dialog=root.querySelector('.sample-dialog');
    var current=0;
    function showSample(index){
      current=(index+cards.length)%cards.length;
      var card=cards[current];
      var img=dialog.querySelector('#sample-expanded');
      img.src=card.dataset.sample;img.alt=card.dataset.title;
      dialog.querySelector('#sample-title').textContent=card.dataset.title;
      dialog.querySelector('[data-sample-count]').textContent=(current+1)+' / '+cards.length;
      dialog.querySelector('[data-full-image]').href=card.dataset.sample;
    }
    if(dialog && !dialog.dataset.bound){
      dialog.dataset.bound='true';
      cards.forEach(function(card,index){card.addEventListener('click',function(){showSample(index);dialog.showModal();});});
      dialog.querySelector('[data-previous]').addEventListener('click',function(){showSample(current-1);});
      dialog.querySelector('[data-next]').addEventListener('click',function(){showSample(current+1);});
      dialog.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();showSample(current+1);}if(e.key==='ArrowLeft'){e.preventDefault();showSample(current-1);}});
    }
    root.querySelectorAll('dialog').forEach(function(d){
      d.querySelectorAll('[data-close]').forEach(function(b){b.addEventListener('click',function(){d.close();});});
      d.addEventListener('click',function(e){if(e.target===d){var r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}});
    });
    root.querySelectorAll('[data-preview-buy]').forEach(function(b){b.addEventListener('click',function(){var preview=root.querySelector('.preview-dialog');if(preview)preview.showModal();});});
    var mobile=root.querySelector('.mobile-buy');
    var hero=root.querySelector('#hero-action');
    var offer=root.querySelector('.offer-copy');
    function syncBuy(){if(!mobile||!hero||!offer)return;var h=hero.getBoundingClientRect();var o=offer.getBoundingClientRect();var show=h.bottom<0&&(o.bottom<0||o.top>window.innerHeight);mobile.classList.toggle('is-visible',show);mobile.inert=!show;}
    if(mobile){syncBuy();window.addEventListener('scroll',syncBuy,{passive:true});window.addEventListener('resize',syncBuy);}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init(document);});}else{init(document);}
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
